module.exports = __webpack_public_path__ + "media/images/logos/05-1632572601fe21a7b89aad698e410f11.png";